import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './components/Dashboard.mjs';
import Lancamentos from './components/Lancamentos.mjs';
import FormularioLancamento from './components/FormularioLancamento.mjs';
import Plataformas from './components/Plataformas.mjs';
import FormularioPlataforma from './components/FormularioPlataforma.mjs';
import FormularioDadosDoGrupo from './components/FormularioDadosDoGrupo.mjs';
import DadosDoGrupo from './components/DadosDoGrupo.mjs';
import EditarPosicao from './components/EditarPosicao.mjs';
import BlankPage from './components/BlankPage.mjs';
import ClientValidator from './components/ClientValidator.mjs';
import GrupoRaque from './components/GrupoRaque.mjs';
import { useClientStorage } from './hooks/useClientStorage.mjs';


function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

function AppContent() {
  useClientStorage(); // Gerencia o storage do cliente
  
  return (
    <Routes>
      {/* Rota raiz - página em branco */}
      <Route path="/" element={<BlankPage />} />
      
      {/* Rota do Grupo VIP Raque - redirect automático */}
      <Route path="/gruporaque" element={<GrupoRaque />} />
      
      {/* Rota com validação de cliente */}
      <Route path="/:clientName" element={
        <ClientValidator>
          <Dashboard />
        </ClientValidator>
      }>
        {/* Sub-rotas dentro do Dashboard */}
        <Route index element={<Lancamentos />} />
        <Route path="lancamentos" element={<Lancamentos />} />
        <Route path="form" element={<FormularioLancamento />} />
        <Route path="form/:id" element={<FormularioLancamento />} />
        <Route path="plataformas" element={<Plataformas />} />
        <Route path="formPlat" element={<FormularioPlataforma />} />
        <Route path="formPlat/:id" element={<FormularioPlataforma />} />
        <Route path="grupo" element={<DadosDoGrupo />} />
        <Route path="formData" element={<FormularioDadosDoGrupo />} />
        <Route path='plataformas/EditarPosicao' element={<EditarPosicao />} />
        {/* Adicione outras rotas conforme necessário */}
      </Route>
    </Routes>
  );
}

export default App;
